import styled from 'styled-components'
import dsTheme from '../../constants/design-system/theme.json'
import { progressiveBreakpoints } from '../../constants/theme'

const { colors } = dsTheme

const Img = styled.img`
  max-width: 400px !important;
  margin: 0 auto 1.125rem;

  @media ${progressiveBreakpoints.desktop} {
    margin: 3rem auto;
  }
`

const ContentWrapper = styled.div`
  @media ${progressiveBreakpoints.desktop} {
    max-width: 402px;
  }

  p {
    color: ${colors['UI/LightGrey']};
    margin-bottom: 3rem;

    @media ${progressiveBreakpoints.desktop} {
      margin-bottom: 0;
    }
  }
`

export { Img, ContentWrapper }
